import { useEffect, useState } from "react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * WardenMeterBlock — Coffin Nail #56 · The cost of honesty itself.
 * Aggregates Warden's Haiku spend vs Sage chat spend and publishes the ratio.
 */
export default function WardenMeterBlock() {
  const [d, setD] = useState(null);
  const [err, setErr] = useState(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const r = await fetch(`${BACKEND_URL}/api/sage/warden/meter`);
        if (!r.ok) throw new Error(`HTTP ${r.status}`);
        const j = await r.json();
        if (!cancelled) setD(j);
      } catch (e) { if (!cancelled) setErr(e.message); }
    })();
    return () => { cancelled = true; };
  }, []);

  return (
    <div className="border border-sage-border p-6" data-testid="ledger-warden-meter">
      <div className="text-xs uppercase tracking-[0.15em] text-sage-muted mb-3">
        The Warden's Meter · the cost of honesty itself
      </div>
      {err && <div className="text-xs text-sage-warn" data-testid="warden-meter-error">unavailable · {err}</div>}
      {!d && !err && <div className="text-xs text-sage-faint">Loading…</div>}
      {d && (
        <>
          <div className="flex items-baseline gap-3 mb-4">
            <div className="text-3xl font-bold tabular-nums text-sage-accent" data-testid="warden-meter-ratio">
              {d.cost_of_honesty_pct?.toFixed(2)}%
            </div>
            <div className="text-[10px] uppercase tracking-[0.15em] text-sage-faint">
              of every dollar Sage spends
            </div>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-4">
            <MeterStat label="Warden reviews" value={d.warden?.reviews} testid="warden-meter-reviews" />
            <MeterStat label="Warden $ burned" value={`$${(d.warden?.cost_usd || 0).toFixed(6)}`} testid="warden-meter-warden-cost" />
            <MeterStat label="Sage chat $ burned" value={`$${(d.sage_chat?.cost_usd || 0).toFixed(6)}`} testid="warden-meter-chat-cost" />
            <MeterStat label="Total burn" value={`$${(d.total_burn_usd || 0).toFixed(6)}`} testid="warden-meter-total" />
          </div>
          <div className="text-xs text-sage-text mb-3">
            <span className="text-sage-faint">per-review avg: </span>
            <span className="tabular-nums" data-testid="warden-meter-per-review">
              ${(d.warden?.cost_per_review_usd || 0).toFixed(6)}
            </span>
            <span className="text-sage-faint"> · per-flag avg: </span>
            <span className="tabular-nums" data-testid="warden-meter-per-flag">
              ${(d.warden?.cost_per_flagged_usd || 0).toFixed(6)}
            </span>
          </div>
          <div className="text-[10px] text-sage-faint leading-relaxed">
            {d.law}
          </div>
        </>
      )}
    </div>
  );
}

function MeterStat({ label, value, testid }) {
  return (
    <div>
      <div className="text-[10px] uppercase tracking-[0.15em] text-sage-faint mb-1">{label}</div>
      <div className="text-sm font-bold tabular-nums" data-testid={testid}>{value ?? "—"}</div>
    </div>
  );
}
